import "styles/page.css";

import { useEffect, useState } from "react";
import parse from "html-react-parser";
import axios from "axios";

import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";
import useStore from "stores/Store";
import { isEmpty } from "lodash";

function Whistleblow() {
  const [whistleblowData, setWhistleblowData] = useState();
  const { aboutState, setAboutState } = useStore();

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/abouts?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setAboutState(jsonResponse);
      setWhistleblowData(
        jsonResponse?.CorporateGovernance[0].WhistleblowingPolicy[0]
      );
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (isEmpty(aboutState)) {
      fetchAboutData();
    } else {
      setWhistleblowData(
        aboutState?.CorporateGovernance[0].WhistleblowingPolicy[0]
      );
    }
  }, []);

  return (
    <>
      <div className="container page">
        <h1 className="page-title">{whistleblowData?.title}</h1>
        {whistleblowData?.description && (
          <p className="page-subtitle">{parse(whistleblowData?.description)}</p>
        )}

        <div className="link-button-row">
          {whistleblowData?.ExternalLink?.map((item, index) => (
            <LinkButton
              key={index}
              text={item?.title}
              onClick={() => {
                handleOpenPdf(item?.link);
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default Whistleblow;
